export const mapStyle = [
    [
        {
            'featureType': 'all',
            'elementType': 'labels',
            'stylers': [
                {
                    'visibility': 'on'
                }
            ]
        },
        {
            'featureType': 'all',
            'elementType': 'labels.text.fill',
            'stylers': [
                {
                    'saturation': 36
                },
                {
                    'color': '#000000'
                },
                {
                    'lightness': 40
                }
            ]
        },
        {
            'featureType': 'all',
            'elementType': 'labels.text.stroke',
            'stylers': [
                {
                    'visibility': 'on'
                },
                {
                    'color': '#000000'
                },
                {
                    'lightness': 16
                }
            ]
        },
        {
            'featureType': 'all',
            'elementType': 'labels.icon',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'administrative',
            'elementType': 'geometry.fill',
            'stylers': [
                {
                    'color': '#000000'
                },
                {
                    'lightness': 20
                }
            ]
        },
        {
            'featureType': 'administrative',
            'elementType': 'geometry.stroke',
            'stylers': [
                {
                    'color': '#000000'
                },
                {
                    'lightness': 17
                },
                {
                    'weight': 1.2
                }
            ]
        },
        {
            'featureType': 'administrative.country',
            'elementType': 'labels.text.fill',
            'stylers': [
                {
                    'color': '#e5c163'
                }
            ]
        },
        {
            'featureType': 'administrative.locality',
            'elementType': 'labels.text.fill',
            'stylers': [
                {
                    'color': '#c4c4c4'
                }
            ]
        },
        {
            'featureType': 'administrative.neighborhood',
            'elementType': 'labels.text.fill',
            'stylers': [
                {
                    'color': '#e5c163'
                }
            ]
        },
        {
            'featureType': 'landscape',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#000000'
                },
                {
                    'lightness': 20
                }
            ]
        },
        {
            'featureType': 'poi',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#000000'
                },
                {
                    'lightness': 21
                },
                {
                    'visibility': 'on'
                }
            ]
        },
        {
            'featureType': 'poi.business',
            'elementType': 'geometry',
            'stylers': [
                {
                    'visibility': 'on'
                }
            ]
        },
        {
            'featureType': 'road.highway',
            'elementType': 'geometry.fill',
            'stylers': [
                {
                    'color': '#e5c163'
                },
                {
                    'lightness': '0'
                }
            ]
        },
        {
            'featureType': 'road.highway',
            'elementType': 'geometry.stroke',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'road.highway',
            'elementType': 'labels.text.fill',
            'stylers': [
                {
                    'color': '#ffffff'
                }
            ]
        },
        {
            'featureType': 'road.highway',
            'elementType': 'labels.text.stroke',
            'stylers': [
                {
                    'color': '#e5c163'
                }
            ]
        },
        {
            'featureType': 'road.arterial',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#000000'
                },
                {
                    'lightness': 18
                }
            ]
        },
        {
            'featureType': 'road.arterial',
            'elementType': 'geometry.fill',
            'stylers': [
                {
                    'color': '#575757'
                }
            ]
        },
        {
            'featureType': 'road.arterial',
            'elementType': 'labels.text.fill',
            'stylers': [
                {
                    'color': '#ffffff'
                }
            ]
        },
        {
            'featureType': 'road.arterial',
            'elementType': 'labels.text.stroke',
            'stylers': [
                {
                    'color': '#2c2c2c'
                }
            ]
        },
        {
            'featureType': 'road.local',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#000000'
                },
                {
                    'lightness': 16
                }
            ]
        },
        {
            'featureType': 'road.local',
            'elementType': 'labels.text.fill',
            'stylers': [
                {
                    'color': '#999999'
                }
            ]
        },
        {
            'featureType': 'transit',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#000000'
                },
                {
                    'lightness': 19
                }
            ]
        },
        {
            'featureType': 'water',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#000000'
                },
                {
                    'lightness': 17
                }
            ]
        }
    ],
    [{
        'featureType': 'administrative',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#d6e2e6'
            }
        ]
    },
    {
        'featureType': 'administrative',
        'elementType': 'geometry.stroke',
        'stylers': [
            {
                'color': '#cfd4d5'
            }
        ]
    },
    {
        'featureType': 'administrative',
        'elementType': 'labels.text.fill',
        'stylers': [
            {
                'color': '#7492a8'
            }
        ]
    },
    {
        'featureType': 'administrative.neighborhood',
        'elementType': 'labels.text.fill',
        'stylers': [
            {
                'lightness': 25
            }
        ]
    },
    {
        'featureType': 'landscape.man_made',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#dde2e3'
            }
        ]
    },
    {
        'featureType': 'landscape.man_made',
        'elementType': 'geometry.stroke',
        'stylers': [
            {
                'color': '#cfd4d5'
            }
        ]
    },
    {
        'featureType': 'landscape.natural',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#dde2e3'
            }
        ]
    },
    {
        'featureType': 'landscape.natural',
        'elementType': 'labels.text.fill',
        'stylers': [
            {
                'color': '#7492a8'
            }
        ]
    },
    {
        'featureType': 'landscape.natural.terrain',
        'stylers': [
            {
                'visibility': 'off'
            }
        ]
    },
    {
        'featureType': 'poi',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#dde2e3'
            }
        ]
    },
    {
        'featureType': 'poi',
        'elementType': 'labels.icon',
        'stylers': [
            {
                'saturation': -100
            }
        ]
    },
    {
        'featureType': 'poi',
        'elementType': 'labels.text.fill',
        'stylers': [
            {
                'color': '#588ca4'
            }
        ]
    },
    {
        'featureType': 'poi.park',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#a9de83'
            }
        ]
    },
    {
        'featureType': 'poi.park',
        'elementType': 'geometry.stroke',
        'stylers': [
            {
                'color': '#bae6a1'
            }
        ]
    },
    {
        'featureType': 'poi.sports_complex',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#c6e8b3'
            }
        ]
    },
    {
        'featureType': 'poi.sports_complex',
        'elementType': 'geometry.stroke',
        'stylers': [
            {
                'color': '#bae6a1'
            }
        ]
    },
    {
        'featureType': 'road',
        'elementType': 'labels.icon',
        'stylers': [
            {
                'saturation': -45
            },
            {
                'lightness': 10
            },
            {
                'visibility': 'on'
            }
        ]
    },
    {
        'featureType': 'road',
        'elementType': 'labels.text.fill',
        'stylers': [
            {
                'color': '#41626b'
            }
        ]
    },
    {
        'featureType': 'road.arterial',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#ffffff'
            }
        ]
    },
    {
        'featureType': 'road.highway',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#c1d1d6'
            }
        ]
    },
    {
        'featureType': 'road.highway',
        'elementType': 'geometry.stroke',
        'stylers': [
            {
                'color': '#a6b5bb'
            }
        ]
    },
    {
        'featureType': 'road.highway',
        'elementType': 'labels.icon',
        'stylers': [
            {
                'visibility': 'on'
            }
        ]
    },
    {
        'featureType': 'road.highway.controlled_access',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#9fb6bd'
            }
        ]
    },
    {
        'featureType': 'road.local',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#ffffff'
            }
        ]
    },
    {
        'featureType': 'transit',
        'elementType': 'labels.icon',
        'stylers': [
            {
                'saturation': -70
            }
        ]
    },
    {
        'featureType': 'transit.line',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#b4cbd4'
            }
        ]
    },
    {
        'featureType': 'transit.line',
        'elementType': 'labels.text.fill',
        'stylers': [
            {
                'color': '#588ca4'
            }
        ]
    },
    {
        'featureType': 'transit.station',
        'elementType': 'labels.text.fill',
        'stylers': [
            {
                'color': '#008cb5'
            }
        ]
    },
    {
        'featureType': 'transit.station.airport',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'saturation': -100
            },
            {
                'lightness': -5
            }
        ]
    },
    {
        'featureType': 'water',
        'elementType': 'geometry.fill',
        'stylers': [
            {
                'color': '#a6cbe3'
            }
        ]
    }
    ],
    [
        {
            'stylers': [
                {
                    'hue': '#ff1a00'
                },
                {
                    'invert_lightness': true
                },
                {
                    'saturation': -100
                },
                {
                    'lightness': 33
                },
                {
                    'gamma': 0.5
                }
            ]
        },
        {
            'featureType': 'water',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#2D333C'
                }
            ]
        }
    ],
    [
        {
            'featureType': 'poi',
            'elementType': 'geometry',
            'stylers': [
                {
                    'visibility': 'simplified'
                }
            ]
        },
        {
            'featureType': 'poi',
            'elementType': 'labels',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'road',
            'stylers': [
                {
                    'visibility': 'simplified'
                }
            ]
        },
        {
            'featureType': 'road',
            'elementType': 'labels',
            'stylers': [
                {
                    'visibility': 'on'
                }
            ]
        }
    ],
    [
        {
            'featureType': 'administrative',
            'elementType': 'labels.text.fill',
            'stylers': [
                {
                    'color': '#444444'
                }
            ]
        },
        {
            'featureType': 'landscape',
            'elementType': 'all',
            'stylers': [
                {
                    'color': '#f2f2f2'
                }
            ]
        },
        {
            'featureType': 'landscape.man_made',
            'elementType': 'geometry.fill',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'poi',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'road',
            'elementType': 'all',
            'stylers': [
                {
                    'saturation': -100
                },
                {
                    'lightness': 45
                }
            ]
        },
        {
            'featureType': 'road.highway',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'simplified'
                }
            ]
        },
        {
            'featureType': 'road.arterial',
            'elementType': 'labels.icon',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'transit',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'water',
            'elementType': 'all',
            'stylers': [
                {
                    'color': '#89dac1'
                },
                {
                    'visibility': 'on'
                }
            ]
        }
    ],

];
